/**
 * InventoriesToolbar Section Component
 *
 * Renders primary action buttons for the inventory listing.
 * Includes the "New inventory item" yellow button.
 */

import { Button } from '@/components/ui/button';
import { PlusIcon } from '../../icons';

interface InventoriesToolbarProps {
  className?: string;
  onCreateNew?: () => void;
  /** RBAC: when false, hide the "New inventory item" write action. */
  canWrite?: boolean;
}

export function InventoriesToolbar({ className, onCreateNew, canWrite = true }: InventoriesToolbarProps) {
  return (
    <div className={className}>
      <div className="flex items-center gap-3">
        {/* New inventory item button */}
        {canWrite && (
          <Button onClick={onCreateNew ?? (() => {})}>
            <PlusIcon className="size-5" aria-hidden="true" />
            New inventory item
          </Button>
        )}
      </div>
    </div>
  );
}
